<template>
    <component :is="component" v-if="component" :itemData="itemData"></component>
</template>

<script>
export default {
    name: "ItemWriteLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        writeLayout: '',
        itemData: {},
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/item/write/ItemWriteDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.writeLayout) {
                return null
            }
            return () => import(`@/template/item/write/${this.writeLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>